<template>
  <div>
    <swiper :options="swiperOption" class="swiper" :class="{swiperbut: bannerList.length}">
        <swiper-slide v-for="(banner, idx) in bannerList" :key="idx">
          <img class="themaBanner" :src="`https://stamp.tranggle.com/${banner.notice_popup_img_url.replace('html/', '')}`" :alt="banner.notice_popup_title" @click="checkUrl(banner.notice_popup_url)"/>
        </swiper-slide>
        <swiper-slide v-if="giftYN || (mainStampList.length && parseInt(mainStampList[0].mingle_badge_inte_point))">
            <div v-if="!giftAuth()" class="gift_box" @click="goGift">
                <div class="gift_price">
                    {{sumPrice}}원 상당의 선물이 가득!!
                </div><br/>
                <button class="view">선물 모두보기</button>
            </div>
            <div v-else class="gift_box" @click="goGift">
                <div class="gift_price">
                    {{giftAuth()}}
                </div><br/>
                <button class="view">{{isAfterCutoffDate ? '신청 바로가기' : (mainStampList.length && parseInt(mainStampList[0].mingle_badge_inte_point)) ? '포인트몰 바로가기' : '신청 바로가기'}}</button>
            </div>
        </swiper-slide>
        <div v-if="bannerList.length" class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import * as appEvent from '@/assets/js/app_event.js'
import router from '@/router'
export default {
  name: 'MainGiftView',
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
        autoplay: {
          delay: 3000
        },
        loop: false
      }
    }
  },
  watch: {
    mingleCode () {
      if (this.mingleCode !== 'iQxiUpF8ZfaGodRQJ6s0mg==') {
        this.$store.dispatch('loadGiftDataNew')
      }
    }
  },
  computed: {
    ...mapState(['sumPrice', 'mingleCode', 'stampCodeInfo', 'bannerList', 'giftYN', 'mainStampList']),
    isAfterCutoffDate () {
      const currentDate = new Date() // 현재 날짜와 시간
      return currentDate >= this.cutoffDate // 기준 날짜 이후인지 확인
    }
  },
  created () {
    this.cutoffDate = new Date('2025-01-31T00:00:00')
  },
  methods: {
    goGift () {
      if (this.isAfterCutoffDate) {
        router.push('/gift')
      } else if (parseInt(this.mainStampList[0].mingle_badge_inte_point)) {
        router.push('/point')
      } else {
        router.push('/gift')
      }
    },
    giftAuth () {
      let cMsg = ''
      this.stampCodeInfo.map((data) => {
        if (data.code === this.mingleCode) {
          cMsg = data.msg
        }
      })
      return cMsg
    },
    fullPathChk () {
      let chk = false
      if (location.href.indexOf('stagestamp') > -1) {
        chk = true
      } else {
        chk = false
      }
      return chk
    },
    checkUrl (url) {
      if (url.indexOf('mstamp.tranggle.com') > -1) {
        // 내부링크
        appEvent.interiorLink(url.split('.com')[1])
      } else {
        // 외부링크
        appEvent.externalLinks(url)
      }
    }
  },
  mounted () {
    if (this.mingleCode && this.mingleCode !== 'iQxiUpF8ZfaGodRQJ6s0mg==') {
      this.$store.dispatch('loadGiftDataNew')
    }
  }
}
</script>
<style>
    .swiper {
      width: 100%;
    }
    .swiperbut {
      padding-bottom:10px!important;
    }
    .swiper-pagination-bullet {
      width:4px!important;
      height:4px!important;
      background:#333!important;
    }
    .swiper-pagination-bullet-active {
      background:#333!important;
    }
    .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
      margin: 0 2px!important;
    }
    .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom:0px!important;
    }
</style>
